import { render, staticRenderFns } from "./FolderBrowser.vue?vue&type=template&id=975fa832&scoped=true&"
import script from "./FolderBrowser.vue?vue&type=script&lang=js&"
export * from "./FolderBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FolderBrowser.vue?vue&type=style&index=0&id=975fa832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975fa832",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/folder/FolderBrowser.vue"
export default component.exports